function getTitle (vm) {
  const { title } = vm.$options
  if (title) {
    return typeof title === 'function'
      ? title.call(vm)
      : title
  }
}

function getDescription(vm) {
  const { description } = vm.$options
  if (description) {
    return typeof description === 'function'
      ? description.call(vm)
      : description
  }
}

function ensureMeta(attrName, attrValue) {
  let el = document.head.querySelector(`meta[${attrName}="${attrValue}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attrName, attrValue)
    document.head.appendChild(el)
  }
  return el
}

function ensureCanonical() {
  let el = document.head.querySelector('link[rel="canonical"]')
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', 'canonical')
    document.head.appendChild(el)
  }
  return el
}

function applyHead(vm) {
  const title = getTitle(vm)
  const description = getDescription(vm)
  const url = window.location.href
  const image = 'https://www.foclarity.com/icons/foclarity-logo.png'

  if (title) {
    document.title = title
    ensureMeta('property', 'og:title').setAttribute('content', title)
    ensureMeta('name', 'twitter:title').setAttribute('content', title)
  }

  if (description) {
    ensureMeta('name', 'description').setAttribute('content', description)
    ensureMeta('property', 'og:description').setAttribute('content', description)
    ensureMeta('name', 'twitter:description').setAttribute('content', description)
  }

  ensureMeta('property', 'og:url').setAttribute('content', url)
  ensureMeta('property', 'og:type').setAttribute('content', 'website')
  ensureMeta('property', 'og:site_name').setAttribute('content', 'Foclarity')
  ensureMeta('property', 'og:image').setAttribute('content', image)
  ensureMeta('name', 'twitter:card').setAttribute('content', 'summary_large_image')
  ensureMeta('name', 'twitter:site').setAttribute('content', '@foclarity')
  ensureMeta('name', 'twitter:image').setAttribute('content', image)
  ensureCanonical().setAttribute('href', url)
}

export default {
  mounted() {
    applyHead(this)
  },
  watch: {
    $route() {
      applyHead(this)
    }
  }
}
